import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Route, Switch } from "react-router-dom";
import PanelGreetingBotPage from "../app/PanelGreetingBotPage";
import User from "~/models/User";
import UserStore from "~/stores/UserStore";
import ToastMessageStore from "~/stores/ToastMessageStore";
import PanelUiMeet3dEventIndexPage from "../app/PanelUiMeet3dEventIndexPage";
import PanelUiMeet3dLeadIndexPage from "../app/PanelUiMeet3dLeadIndexPage";
import LoggedInCustomerWrapper from "~/applications/panel/components/LoggedInCustomerWrapper";
import ClientPanelUiMeet3dHomePage from "~/applications/panel/app/ClientPanelUiMeet3dHomePage";
import ClientPanelUiMeet3dGeneralPage from "~/applications/panel/app/ClientPanelUiMeet3dGeneralPage";
import ClientPanelUiMeet3dNotificationSettingsPage from "~/applications/panel/app/ClientPanelUiMeet3dNotificationSettingsPage";
import PanelUiMeet3dCompletedMeetingIndexPage from "~/applications/panel/app/PanelUiMeet3dCompletedMeetingIndexPage";

@observer
class UiMeet3dRoutes extends Component {
  render() {
    const { user, userStore, toastMessageStore, ...rest } = this.props;

    return (
      <Switch>
        <Route
          exact
          path="(/ui-meet-3d/greeting-bot)"
          render={props => (
            <PanelGreetingBotPage {...props} user={user} userStore={userStore} toastMessageStore={toastMessageStore} />
          )}
        />
        <Route
          exact
          path="(/ui-meet-3d/events)"
          render={props => <PanelUiMeet3dEventIndexPage {...props} toastMessageStore={toastMessageStore} />}
        />
        <Route
          exact
          path="(/ui-meet-3d/leads)"
          render={props => <PanelUiMeet3dLeadIndexPage {...props} toastMessageStore={toastMessageStore} />}
        />
        <Route
          exact
          path="(/ui-meet-3d/meetings)"
          render={props => <PanelUiMeet3dCompletedMeetingIndexPage {...props} toastMessageStore={toastMessageStore} />}
        />
        <Route
          path="/ui-meet-3d"
          render={routeProps => (
            <LoggedInCustomerWrapper user={user} {...rest} {...routeProps}>
              {({ customerStore }) => (
                <Switch>
                  <Route
                    exact
                    path="(/ui-meet-3d)"
                    render={innerRouteProps => (
                      <ClientPanelUiMeet3dHomePage
                        actualUserStore={customerStore}
                        toastMessageStore={toastMessageStore}
                        {...innerRouteProps}
                        {...rest}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="(/ui-meet-3d/general)"
                    render={innerRouteProps => (
                      <ClientPanelUiMeet3dGeneralPage
                        actualUserStore={customerStore}
                        toastMessageStore={toastMessageStore}
                        {...innerRouteProps}
                        {...rest}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="(/ui-meet-3d/notifications)"
                    render={innerRouteProps => (
                      <ClientPanelUiMeet3dNotificationSettingsPage
                        actualUserStore={customerStore}
                        toastMessageStore={toastMessageStore}
                        {...innerRouteProps}
                        {...rest}
                      />
                    )}
                  />
                </Switch>
              )}
            </LoggedInCustomerWrapper>
          )}
        />
      </Switch>
    );
  }
}

UiMeet3dRoutes.propTypes = {
  user: PropTypes.instanceOf(User),
  userStore: PropTypes.instanceOf(UserStore),
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
};

export default UiMeet3dRoutes;
